<template>
  <v-container
    id="dashboard"
    fluid
    tag="section"
  >
    <div class="d-flex justify-space-between dashboardTopBar">
      <div class="d-flex ms-auto dashboardFilterBar">
        <header-filters
          class-name="dashboard"
          :filter-names="['make', 'model']"
          is-date-show
          :date-selected="'last_30_days'"
          :date-validation="false"
          @onChange="onFiltersChange"
        />
        <div class="marleftCustom">
          <card-options
            :options="options"
            :tenant-tech="vehicle_tech"
            @change="callSectionData"
          />
        </div>
      </div>
    </div>
    <section class="sections-wrapper">
      <section-one
        v-if="
          dashboadSortData.section_1 && dashboadSortData.section_1.length > 0
        "
        :loading="sectionOneLoader"
        :options="options"
        :vehicle-tech="vehicle_tech"
      />
      <div class="row marZero">
        <section-two
          v-if="
            dashboadSortData.section_2 && dashboadSortData.section_2.length > 0
          "
          :loading="sectionTwoLoader"
          :options="options"
          :vehicle-tech="vehicle_tech"
        />

        <section-three
          v-if="
            dashboadSortData.section_3 && dashboadSortData.section_3.length > 0
          "
          :loading="sectionThreeLoader"
          :options="options"
          :vehicle-tech="vehicle_tech"
        />
      </div>
      <section-four
        v-if="
          dashboadSortData.section_4 && dashboadSortData.section_4.length > 0
        "
        :loading="sectionFourLoader"
        :options="options"
        :vehicle-tech="vehicle_tech"
      />
    </section>
  </v-container>
</template>
<script>
// import { debounce } from "lodash";
import { mapGetters } from "vuex";
export default {
  name: "DashboardDashboard",
  components: {
    HeaderFilters: () => import("@/layouts/section/MainFilters.vue"),
    SectionOne: () => import("./sections/SectionOne.vue"),
    SectionTwo: () => import("./sections/SectionTwo.vue"),
    SectionThree: () => import("./sections/SectionThree.vue"),
    SectionFour: () => import("./sections/SectionFour.vue"),
    CardOptions: () => import("./utils/CardOptions.vue"),
  },
  data() {
    return {
      isFetching: false,
      drawer: false,
      options: {},
      headers: [
        {
          text: this.$t("fuel_vehicle_cost"),
          align: "left",
          sortable: false,
          value: "fuel_cost",
          // width: "5%",
        },
        {
          text: this.$t("electric_vehicle_cost"),
          align: "left",
          sortable: false,
          value: "electricity_cost",
          // width: "15%",
        },
        {
          text: this.$t("savings"),
          align: "left",
          sortable: false,
          value: "savings",
          // width: "15%",
        },
      ],
      sectionOneLoader: true,
      sectionTwoLoader: true,
      sectionThreeLoader: true,
      sectionFourLoader: true,
      isActiveModal: false,

      //
      requestGroups: new Map(),
      groupId: "abc-123",
    };
  },
  computed: {
    ...mapGetters({
      authUser: "getUser",
      tenantLoading: "tenantsManagement/getIsLoading",
      tenantsList: "tenantsManagement/getTenantOptions",
      listMdModels: "mdModels/listMdModels",
      isLoading: "dashboard/getIsLoading",
      dashboardLoading: "dashboard/getDashoardLoading",
      dashboadData: "dashboard/getDashboadData",
      dashboadSortData: "dashboard/getDashboadSortData",
      getCardOptions: "dashboard/getCardOptions",
    }),
    isTwoWheeler() {
      const vType = this.dashboadData.vehicle_type;
      return vType?.length > 0 ? vType.every((r) => r == "two_wheeler") : false;
    },
    vehicle_tech() {
      if (this.authUser.isAdmin) {
        let tId = null;
        if (this.options.product == "oem") {
          tId = this.options.tenant_id;
        } else if (this.options.product == "fleet") {
          tId = this.options.fleetId;
        }
        const tRow = this.tenantsList.find((r) => r.id == tId);

        return tRow?.vehicle_tech || "ev"; //when nothing set ev
      } else {
        return this.authUser.user_tech;
      }
    },
  },
  watch: {},
  beforeDestroy() {
    const params = {
      name: "dashboard",
      filters: this.options,
    };
    this.$store.commit("redirect/SET_FILTERS", params);
  },

  methods: {
    async fetchData() {
      // if (this.isFetching) return; // Prevent duplicate API calls
      // this.isFetching = true;
      // Start loading
      //  // Cancel any ongoing requests in the same group
      this.cancelRequestGroup();

      // Track the new request
      const controller = this.trackRequest();

      //
      this.$store.dispatch("dashboard/setDashboardLoader", true);
      this.sectionOneLoader = true;
      this.sectionTwoLoader = true;
      this.sectionThreeLoader = true;
      this.sectionFourLoader = true;
      try {
        const params = {
          vehicle_tech: this.vehicle_tech,
          tenant_id: this.options.tenant_id,
          signal: controller.signal,
        };
        await this.$store.dispatch("dashboard/dashboardCardOptions", params);
        const data = await this.$store.dispatch(
          "dashboard/userDashboardCards",
          {
            ...params,
            dashboard_type: "customized",
          }
        );
        // Fetch specific section data
        await this.sectionsAPIs(data, "fetchData", "", controller.signal);
      } catch (error) {
        return;
      } finally {
        // Stop loading
        this.isFetching = false;
        this.$store.dispatch("dashboard/setDashboardLoader", false);
      }
    },
    callSectionData(val, item) {
      this.sectionsAPIs(this.dashboadSortData, val, item);
    },
    async sectionsAPIs(data, val, sectionName = "", signal) {
      const section_1 = data.section_1
        ? data.section_1.map((card) => card.card_name)
        : [];
      const section_2 = data.section_2
        ? data.section_2.map((card) => card.card_name)
        : [];
      const section_3 = data.section_3
        ? data.section_3.map((card) => card.card_name)
        : [];
      const section_4 = data.section_4
        ? data.section_4.map((card) => card.card_name)
        : [];

      // Handle the logic based on the value of `val`
      if (val === "cardOption") {
        // Trigger only the specific sectionName API
        switch (sectionName) {
          case "section_1":
            this.$store
              .dispatch("dashboard/sectionOneList", {
                ...this.options,
                signal,
              })
              .then(() => (this.sectionOneLoader = false));
            break;
          case "Vehicle Status":
            this.$store
              .dispatch("dashboard/vechicleStatusList", {
                ...this.options,
                signal,
              })
              .then(() => (this.sectionTwoLoader = false));
            break;
          case "Trips":
            this.$store
              .dispatch("dashboard/vechicleTrips", {
                ...this.options,
                signal,
              })
              .then(() => (this.sectionTwoLoader = false));
            break;
          case "Charge Sessions":
            this.$store
              .dispatch("dashboard/sectionChargeSession", {
                ...this.options,
                signal,
              })
              .then(() => (this.sectionThreeLoader = false));
            break;
          case "Cost Analysis":
            this.$store
              .dispatch("dashboard/sectionThreeList", {
                ...this.options,
                signal,
              })
              .then(() => (this.sectionThreeLoader = false));
            break;
          case "Map":
            this.$store
              .dispatch("dashboard/sectionFourList", {
                ...this.options,
                signal,
              })
              .then(() => (this.sectionFourLoader = false));
            this.getVehicleList(signal);
            break;
          case "Most Idle Time":
            this.$store
              .dispatch("dashboard/sectionFourList", {
                ...this.options,
                signal,
              })
              .then(() => (this.sectionFourLoader = false));
            break;
          case "Top Over Speeding":
            this.$store
              .dispatch("dashboard/sectionFourList", {
                ...this.options,
                signal,
              })
              .then(() => (this.sectionFourLoader = false));
            break;
          default:
            break;
        }
      } else if (val === "fetchData") {
        // Trigger all the APIs for all sections
        if (section_1.length > 0) {
          this.$store
            .dispatch("dashboard/sectionOneList", {
              ...this.options,
              signal,
            })
            .then(() => (this.sectionOneLoader = false));
        }
        if (section_4.length > 0) {
          this.$store
            .dispatch("dashboard/sectionFourList", {
              ...this.options,
              signal,
            })
            .then(() => (this.sectionFourLoader = false));
          if (section_4.some((item) => item === "Map")) {
            this.getVehicleList(signal);
          }
        }
        if (section_2.includes("Vehicle Status")) {
          await this.$store.dispatch("dashboard/vechicleStatusList", {
            ...this.options,
            signal,
          });
        }
        if (section_2.includes("Trips")) {
          await this.$store.dispatch("dashboard/vechicleTrips", {
            ...this.options,
            signal,
          });
        }
        this.sectionTwoLoader = false;

        if (section_3.includes("Charge Sessions")) {
          await this.$store.dispatch("dashboard/sectionChargeSession", {
            ...this.options,
            signal,
          });
        }
        if (section_3.includes("Cost Analysis")) {
          await this.$store.dispatch("dashboard/sectionThreeList", {
            ...this.options,
            signal,
          });
        }
        this.sectionThreeLoader = false;
      }
    },
    // onFiltersChange: debounce(function (v) {
    // }, 1000),
    onFiltersChange(v) {
      delete this.options.product;
      delete this.options.fleetId;
      delete this.options.oem_b2b_ids;
      delete this.options.is_independent_fleet;
      delete this.options.tenant_id;
      this.options = { ...this.options, ...v };
      const initialBreadcrumb = [
        {
          date: "Reset",
          start: this.options.date ? this.options.date[0] : null,
          end: this.options.date ? this.options.date[1] : null,
        },
      ];
      this.$store.dispatch("dashboard/setTripReset", initialBreadcrumb);
      this.$store.dispatch("dashboard/setTripBreadCrumb", []);
      this.$store.dispatch("dashboard/setChargeReset", initialBreadcrumb);
      this.$store.dispatch("dashboard/setChargeBreadCrumb", []);
      this.fetchData();
    },
    async getVehicleList(signal) {
      if (this.options.tenant_id || this.options.fleetId) {
        this.$store.commit("vehicles/SET_VEHICLES", []);
        const params = {
          ...this.options,
          signal,
        };
        // await this.$store.dispatch("vehicles/list", params);
        await this.$store.dispatch("vehicles/getVehiclesMQTT", params);
      }
      // }
    },
    goToTelematics(val) {
      const params = {};
      if (this.authUser.isAdmin) {
        if (this.options.product == "oem") {
          params.product = this.options.product;
          params.tenant_id = this.options.tenant_id;
        } else if (this.options.product == "fleet") {
          params.product = this.options.product;
          params.fleetId = this.options.fleetId;
          params.oem_b2b_ids = this.options.oem_b2b_ids;
          params.tenant_id = this.options.tenant_id;
        }
      } else if (this.authUser.user_nature == "fleet") {
        params.tenant_id = this.options.tenant_id;
      }
      if (val) {
        params.status = val;
      }
      return this.$router.push({
        name: "vehicle_telematics",
        query: params,
      });
    },
    activeTripAction() {
      this.isActiveModal = true;
    },

    // Function to cancel all requests in a specific group
    cancelRequestGroup() {
      if (this.requestGroups.has(this.groupId)) {
        const controllers = this.requestGroups.get(this.groupId);
        controllers.forEach((controller) => controller.abort());
        this.requestGroups.delete(this.groupId); // Clear the group after cancellation
      }
    },

    // Function to track a new request in a specific group
    trackRequest() {
      const controller = new AbortController();
      if (!this.requestGroups.has(this.groupId)) {
        this.requestGroups.set(this.groupId, []);
      }
      this.requestGroups.get(this.groupId).push(controller);
      return controller;
    },
  },
};
</script>
<style lang="sass" scoped>
.dashboardTopBar
  padding: 0 12px
  align-items: center

#dashboard
  padding: 12px 0

.sections-wrapper
  display: flex
  gap: 1rem
  flex-direction: column

:deep .v-select
  .v-select__selections
    span
      width: 70px
      white-space: nowrap
      overflow: hidden
      text-overflow: ellipsis

@media only screen and (max-width: 960px)
  .sections-wrapper
    flex-direction: column

//   #content-wrapper
//     .content-container
//       flex-direction: column
//       .box-container
//         order: 2
//       .tags-container
//         order: 3
//       .mapAndTop5
//         order: 1
</style>
/* Small devices (portrait tablets and large phones, 600px and up) */ @media
only screen and (min-width: 600px) { .box { width: 250px !important; } }
